import { Link, usePage } from '@inertiajs/react'
import { PaymentMarks } from './PaymentMarks'
import { useTranslation } from '@/lib/i18n'
import type { SharedProps } from '@/types'

/** Keep the identity visible; fold secondary registration details without removing them from the DOM. */
export function SellerDetails() {
  const { seller } = usePage<SharedProps>().props
  const { t } = useTranslation()
  if (!seller) return null

  return (
    <section id="seller-details" className="grid gap-6 border-t border-hairline pt-5 text-xs leading-relaxed text-ink-muted lg:grid-cols-2">
      <div>
        <p className="m-0 font-medium text-ink">{seller.name} · {t('requisites.unp')} {seller.unp}</p>
        <p className="m-0 mt-1 max-w-xl">{seller.address}</p>
        <p className="m-0 mt-1 flex flex-wrap gap-x-3 gap-y-1">
          <a href={`tel:${seller.phoneHref}`} className="hover:text-ink">{seller.phone}</a>
          <a href={`mailto:${seller.email}`} className="hover:text-ink">{seller.email}</a>
        </p>
        <details className="group mt-1">
          <summary className="w-fit cursor-pointer py-2 text-ink-faint hover:text-ink focus-visible:outline focus-visible:outline-2">
            {t('requisites.title')}
          </summary>
          <dl className="m-0 grid gap-3 pt-1">
            <div><dt className="text-ink-faint">{t('requisites.registration')}</dt><dd className="m-0">{seller.registrationAuthority}, {seller.registrationDate}, № {seller.registrationNumber}</dd></div>
            <div><dt className="text-ink-faint">{t('requisites.hours')}</dt><dd className="m-0">{seller.hours}<br />{seller.hoursNote}</dd></div>
            <div><dt className="text-ink-faint">{t('requisites.address')}</dt><dd className="m-0">{seller.postalAddress}</dd></div>
            {seller.tradeRegisterNumber && seller.tradeRegisterDate && (
              <div><dt className="text-ink-faint">{t('requisites.trade_register')}</dt><dd className="m-0">№ {seller.tradeRegisterNumber}, {seller.tradeRegisterDate}</dd></div>
            )}
          </dl>
        </details>
      </div>
      <div className="lg:justify-self-end">
        <PaymentMarks />
        <Link href="/payment" className="mt-3 block text-ink-faint hover:text-ink">
          {seller.cardPaymentsAvailable ? t('requisites.payments') : t('requisites.payment_status')}
        </Link>
      </div>
    </section>
  )
}
